import InteractiveProposalAppendix from "../../InteractiveProposal/menuPages/Appendix/InteractiveProposalAppendix";

function AppendixIntRev() {
  return (
    <div>
      <InteractiveProposalAppendix />
    </div>
  );
}
export default AppendixIntRev;
